import React from "react";
import { motion } from "framer-motion";
import "../../css/exam/CreateExam.css"
import Header from "../Header";
import Footer from "../Footer";
import { useAuth } from "react-oidc-context";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import AuthRequired from "../AuthRequired";
import { createExam } from "../../actions/examSlice";

const examTypes = [
    {
        id: "IAAT",
        title: "Iowa Algebra Aptitude Test",
        description: "Measures algebra readiness for middle school students(Grade 6).",
        icon: "/IAATTest.PNG",
        comingSoon: false,
    },
    {
        id: "NNAT",
        title: "Naglieri Nonverbal Ability Test",
        description: "Evaluates problem-solving and reasoning skills(Level B - Grade 1).",
        icon: "/NNATTest.PNG",
        comingSoon: false,
    },
    {
        id: "COGAT",
        title: "Cognitive Abilities Test",
        description: "Assesses verbal, nonverbal, and quantitative abilities (Level 8 - Grade 2).",
        icon: "/COGATTest.PNG",
        comingSoon: false,
    },
    {
        id: "SAT",
        title: "Scholastic Assessment Test",
        description: "Standardized test for college admissions.",
        icon: "/SATTest.PNG",
        comingSoon: true,
    },
];

const CreateExam = () => {
    const auth = useAuth();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handleCreateExam = async (examId, comingSoon) => {
        if (comingSoon) {
            alert(`"${examId}" exams are coming soon!`);
        } else {
            if (!auth.user?.id_token) return;

            const resultAction = await dispatch(createExam({
                userId: auth.user.profile['cognito:username'],
                token: auth.user.id_token,
                examType: examId
            }));

            if (resultAction?.payload?.status === 200) {
                navigate("/account"); // Navigate on success
            } else {
                alert(`Failed to create exam: Please contact Admin.`); // Show error on failure
            }
        }
    };
    if (auth.isAuthenticated) {
        return (

            <div>
                <Header />
                <div className="create-exam-container">
                    <h2 className="title">Select an Exam Type</h2>

                    <div className="exam-grid">
                        {examTypes.map((exam) => (
                            <motion.div
                                key={exam.id}
                                className={`exam-card ${exam.comingSoon ? "disabled" : ""}`}
                                whileHover={{ scale: 1.02 }}
                                whileTap={{ scale: 0.98 }}
                                onClick={() => handleCreateExam(exam.id, exam.comingSoon)}
                            >
                                <div className="exam-icon-container">
                                    <img src={exam.icon} alt={exam.title} className="exam-icon" />
                                </div>
                                <div className="exam-info">
                                    <h3 className="exam-title">{exam.title}</h3>
                                    <p className="exam-description">{exam.description}</p>
                                    {exam.comingSoon && <span className="coming-soon">Coming Soon!!</span>}
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
    else {
        return (<AuthRequired />);
    }
};

export default CreateExam;
